<div class="navbar-scrollable-dropdown menu-hover menu-border">
  <ul class="link-list">
    <li class="list-header">
      <ng-content select="[header-content]"></ng-content>
    </li>
    <li class="list-content-scrollable" tabindex="-1">
      <ng-content select="[list-content]"></ng-content>
    </li>
  </ul>
</div>
